import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-backlog",
  "use": "icon-backlog-usage",
  "viewBox": "0 0 9 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 9 12\" id=\"icon-backlog\">\n    <path fill=\"currentColor\" d=\"M1.35 0C.61 0 0 .625 0 1.385v8.307c0 .601.377 1.11.9 1.3v-1.3c0-.254.202-.461.45-.461H9V0H1.35zm0 .923H8.1v7.385H1.35c-.158 0-.309.033-.45.084V1.385c0-.26.197-.462.45-.462zm.45.923v.923h.9v-.923h-.9zm0 1.846v.923h.9v-.923h-.9zm0 1.846v.924h.9v-.924h-.9zm0 4.616V12l1.35-.923L4.5 12v-1.846H1.8zm3.6 0v.923H9v-.923H5.4z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol